import {FilterValue} from 'antd/es/table/interface';
import {showCommunicationError} from 'helpers/alerts';
import {action, runInAction} from 'mobx';
import {TableState} from 'store/common/TableState';
import {
  ApiServiceActionGetAllTasksForUserGetRequest,
  ServiceStatus,
  ServiceTaskDto,
} from '../../../../../PRMGApiClient';
import {Api} from '../../../../../PRMGApiClient/ApiClient';

type TaskFilters = Pick<
  ApiServiceActionGetAllTasksForUserGetRequest,
  'filtersAssigneeId' | 'filtersDateRangeStart' | 'filtersDateRangeEnd' | 'filtersStatus'
>;

export class TasksState extends TableState<ServiceTaskDto, TaskFilters> {
  constructor() {
    super();
  }

  @action
  loadTableItems() {
    this.isLoading = true;
    Api.ServiceAction.apiServiceActionGetAllTasksForUserGet({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortPropertyName: this.sortPropertyName,
      sortDirection: this.sortDirection,
      ...this.filters,
    })
      .then((res) => {
        runInAction(() => {
          this.items = res.content?.items || [];
          this.total = res.content?.total || 0;
        });
      })
      .catch(showCommunicationError)
      .finally(() => {
        this.isLoading = false;
      });
  }

  setFilters(filters: Record<keyof ServiceTaskDto, FilterValue | null>) {
    this.filters.filtersStatus = (filters.status as ServiceStatus[]) ?? undefined;
    this.filters.filtersDateRangeStart = this.getDate(filters.startDateTime);
    this.filters.filtersDateRangeEnd = this.getDate(filters.endDateTime);
    this.filters.filtersAssigneeId = (filters.assignee as number[]) ?? undefined;
    this.loadTableItems();
  }
}
